import React, { PropsWithChildren, useEffect, useRef } from 'react';

import { isNotNull } from '../../../lib/typeGuards';
import useScrollAreaContext from './ScrollAreaContext';

type ScrollAreaProps = PropsWithChildren<{
  to: number;
  bottomOffset: number;
}>;

/**
 * Wraps an given Component into a scrollable view.
 */
function ScrollArea({ children, to = 80, bottomOffset = 0 }: ScrollAreaProps) {
  const wrapper = useRef<HTMLDivElement | null>(null);
  const { visible } = useScrollAreaContext();

  useEffect(() => {
    const { current } = wrapper;
    if (isNotNull(current)) {
      const height =
        (window.innerHeight / 100) * to -
        current.getBoundingClientRect().top -
        bottomOffset;
      const heightInRem = height ? Math.ceil(height / 16) : 0;
      current.style.maxHeight = `${heightInRem}rem`;
    }
    // ignore warning: recalculate only if 'visible' changes
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [visible]);

  return (
    <div ref={wrapper} className="scroll-area">
      {children}
    </div>
  );
}

export default ScrollArea;
